<template>
    <v-content>
        <v-container>
            <v-card>
                <v-card-title>Estados de baterias
                    <v-spacer></v-spacer>
                    <v-dialog
                            ref="dialog"
                            v-model="modal"
                            :return-value.sync="date"
                            persistent
                            width="290px"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                    v-model="date"
                                    label="Seleccione fecha"
                                    prepend-icon="event"
                                    readonly
                                    v-on="on"
                            />
                        </template>
                        <v-date-picker v-model="date" scrollable locale="es-co">
                            <v-spacer/>
                            <v-btn text color="primary" @click="modal = false">Cancelar</v-btn>
                            <v-btn text color="primary" @click="$refs.dialog.save(date)">Aceptar</v-btn>
                        </v-date-picker>

                    </v-dialog>
                    <v-select class="mx-2"
                              prepend-icon="fa-user"
                              label="Seleccione un usuario"
                              v-model="user"
                              :items="users"
                              item-text="first_name"
                              item-value="id"
                    />
                    <v-btn color="primary" :loading="cargando" :disabled="cargando" @click="getBatteries()">Obtener</v-btn>
                </v-card-title>
                <v-alert v-if="errorMsg" :key="errorMsg" :type="errorTipo" dense dismissible class="mx-4">{{ errorMsg }}</v-alert>
                <v-timeline :dense="$vuetify.breakpoint.smAndDown">
                    <v-timeline-item  v-for="(item, index) in batteries" :key="index" >
                        <v-card >
                            <v-card-title class="blue darken-1 justify-center ">{{ item.createdAt.toDate() | moment("dddd, MMMM Do YYYY, h:mm:ss a")}}</v-card-title>
                            <v-container>
                                <v-row>
                                    <v-col md="2">
                                        <v-icon size="64">{{ getIconBattery(item.level) }}</v-icon>
                                    </v-col>
                                    <v-col cols="12" md="8">
                                        <h3 class="display-3 ml-2 text-center">{{ item.level }}</h3>
                                    </v-col>
                                    <v-col md="2">
                                        <v-icon size="64">{{ getIconPlug(item.status) }}</v-icon>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                    </v-timeline-item>
                </v-timeline>
            </v-card>
        </v-container>
    </v-content>
</template>

<script>
    import {db} from "../plugins/db";
    import {mapState} from "vuex";
    export default {
        name: "Battery",
        data(){
            return{
                modal:false,
                date:'',
                user:'',
                batteries:[],
                cargando: false,
                errorMsg: '',
                errorTipo: 'info'
            }
        },
        methods:{
           // Mismo arreglo que en Control.vue: sin fecha elegida, `$moment('')` es un
           // momento invalido y el Date que salia de ahi hacia que el SDK de Firestore
           // tirara `RangeError: Invalid time value` al convertirlo.
           async getBatteries(){
                this.batteries = [];
                this.errorMsg = '';

                if (!this.$moment(this.date, 'YYYY-MM-DD', true).isValid()) {
                    this.errorTipo = 'info';
                    this.errorMsg = 'Elegi una fecha.';
                    return;
                }
                if (!this.user) {
                    this.errorTipo = 'info';
                    this.errorMsg = 'Elegi un usuario.';
                    return;
                }

                const desde = this.$moment(this.date).startOf('day').toDate();
                const hasta = this.$moment(this.date).add(1, 'days').startOf('day').toDate();

                this.cargando = true;
                try {
                    const batteries = await db.collection('battery')
                        .where('user.id', '==', this.user)
                        .where('createdAt', '>=', desde)
                        .where('createdAt', '<', hasta)
                        .orderBy('createdAt', 'desc')
                        .get();

                    batteries.forEach(e => this.batteries.push(e.data()));

                    if (this.batteries.length === 0) {
                        this.errorTipo = 'info';
                        this.errorMsg = 'No hay registros de bateria para ese usuario en esa fecha.';
                    }
                } catch (error) {
                    this.errorTipo = 'error';
                    this.errorMsg = 'No se pudieron cargar los registros. Revisa la conexion e intenta de nuevo.';
                } finally {
                    this.cargando = false;
                }
            },
            getIconPlug(status){

               if(status){
                   return 'battery_charging_full';
               }else {
                   return 'fa-plug'
               }
            },
            getIconBattery(level){
               if (level >= 90){
                    return 'fa-battery-full'
               }
               if (level <90 && level >= 75){
                    return 'fa-battery-three-quarters'
               }
               if (level < 75 && level >= 50){
                    return 'fa-battery-half'
               }
               if (level < 50 && level >= 25){
                    return 'fa-battery-quarter'
               }
               if (level < 25){
                    return 'fa-battery-empty'
               }

            }
        },
        computed:{
            ...mapState({
                users:state =>state.user.users
            })
        }
    }
</script>

<style scoped>

</style>